// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"13b7cb93","200":"0b63ce61","216":"6ac69c51","432":"cbf5bf3d","640":"34378e1f"}[chunkId] + ".chunk.css";
};